export default {
  props: {
    inputFormat: {
      type: String,
      default: 'DD/MM/YYYY' // hh:mm:ss
    },

    value: {
      type: [Object, Number, String],
      default: undefined
    },
  }
};
